export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";